import React from "react";
import { makeStyles } from 'tss-react/mui';
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import AdminDialog from "./adminDialog";
import { formatUsPhone } from "../utils/contacts";

const useStyles = makeStyles()((theme) => ({
  // What is about to be deleted, named so it cannot be the wrong one.
  item: {
    padding: theme.spacing(1, 1.5),
    borderRadius: 10,
    fontSize: 14.5,
    fontWeight: 500,
    lineHeight: 1.4,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
    wordBreak: "break-word",
  },
  textButton: {
    textTransform: "none",
    color: theme.palette.text.secondary,
  },
  danger: {
    textTransform: "none",
    minWidth: 112,
    color: "#fff",
    backgroundColor: "#d0312d",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#b52a26",
      boxShadow: "none",
    },
  },
}));

// The kind of thing an item is, from the id it carries, and a name for it.
const describe = (item, type) => {
  const given = String(type || "").toLowerCase();
  if (!item) return { noun: given || "item", name: "" };
  const has = (key) => Object.prototype.hasOwnProperty.call(item, key);
  const person = `${item.firstName || ""} ${item.lastName || ""}`.trim();
  if (has("cid")) return { noun: "conference", name: String(item.name || "") };
  if (has("hid")) return { noun: "holiday", name: String(item.name || "") };
  if (has("rid")) return { noun: "recording", name: String(item.title || "") };
  if (has("fid")) return { noun: "fax", name: String(item.title || "") || String(formatUsPhone(item.from) || "") };
  if (has("vid")) return { noun: "voicemail", name: String(item.name || "") || String(formatUsPhone(item.number) || "") };
  if (has("jid")) return { noun: "call", name: String(item.name || "") || String(formatUsPhone(item.number) || "") };
  if (person !== "") return { noun: "contact", name: person };
  return { noun: given || "item", name: String(item.name || item.title || "") };
};

const DeleteForeverConfirmation = (props) => {
    const { classes } = useStyles();
    const { open, setOpen, item,type,handleDeleteForever} = props;

    const processDeletion = ()=>{
      handleDeleteForever(item);
      setOpen(false);
    }

    if (!open) return null;

    const { noun, name } = describe(item, type);

    return (
      <AdminDialog
        open={open}
        onClose={() => setOpen(false)}
        icon={<DeleteIcon />}
        tone="danger"
        title={`Delete this ${noun}?`}
        subtitle="This cannot be undone."
        footer={
          <>
            <Button autoFocus onClick={() => setOpen(false)} className={classes.textButton}>
              Cancel
            </Button>
            <Button
              variant="contained"
              className={classes.danger}
              onClick={processDeletion}
            >
              Delete
            </Button>
          </>
        }
      >
        {name.trim() !== "" && <div className={classes.item}>{name.trim()}</div>}
      </AdminDialog>
    );
}

export default DeleteForeverConfirmation;
